import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { DiagnosticsPanel } from '@common/components/diagnostics-panel';

interface RunDiagnosticsActionProps {
  userId: string;
  open: boolean;
  onClose: () => void;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
}

export function RunDiagnosticsAction({
  userId,
  open,
  onClose,
}: RunDiagnosticsActionProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>Run WA Communication Layer Diagnostics</DialogTitle>
      <DialogContent>
        <DiagnosticsPanel supportedUserId={userId} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
